import http from '~/http/index';

export default ({
  state: {
    data: [],
    additionalData: {},
    grossProfitFull: {},
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },

    SET_ADDITIONAL_DATA(state, data) {
      state.additionalData = data;
    },

    SET_GROSS_PROFIT_FULL(state, data) {
      state.grossProfitFull = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.post('v2/Finance/GetGrossProfit', {
        ...getters.requestData,
        ...data,
      });
      const {
        cumulativeCurrencyId,
        cumulativeCurrencyTitle,
        cumulativeProfit,
        currencies,
        dateFrom,
        dateTo,
        items,
        total,
      } = response.data;
      commit('SET_DATA', items);
      commit('SET_ADDITIONAL_DATA', {
        cumulativeCurrencyId,
        cumulativeCurrencyTitle,
        cumulativeProfit,
        currencies,
        dateFrom,
        dateTo,
      });
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async loadGrossProfitFull({ state, commit }) {
      const response = await http.post('v2/Finance/GetGrossProfitFull', {
        ...state.filters,
      });
      const { data } = response;
      commit('SET_GROSS_PROFIT_FULL', data);
    },
  },

  namespaced: true,
});
